<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('global.contact_request') }}
      </th>
      <th scope="col" class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
        {{ $t('global.assigned_to') }}
      </th>
      <th scope="col" class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
        {{ $t('global.project') }}
      </th>
      <th scope="col" class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
        {{ $t('global.pipeline_stage') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-32 text-right"
      >
        {{ $t('global.date_created') }}
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
